import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';
import searchbarImage from '../../assets/images/search.svg';
import { Link } from 'react-router-dom';
import './common.css';
import { useRefresh } from '../../contexts/refreshLogin';
import { useSelector, useDispatch } from 'react-redux';
import { selectGeo, selectIsPincodeLoading, selectShowCityPopup, setIsForceShow, setShowCityPopup } from '../../redux/slices/pincode';
import { Spinner } from 'react-bootstrap';
import { CartIcon } from './CartIcon';
import { LoginInitialsButton } from './LoginInitialsButton';
import { selectLoggedUser, setLoggedUser } from '../../redux/slices/auth';
import { setCartCount } from '../../redux/slices/cart';
import { redirectToSellUsed, showToastWarning } from '../../shared/utils/utils';
import { UserActivityType } from '../../shared/api/version_1/activity';
import { useApi } from '../../shared/api';
import { SitePath } from '../../shared/constants';
import {  categoryViewEvent } from '../../shared/events/product.event';
import { aboutUsClickedEvent, faqClickedEvent, homeButtonClickedEvent, sellNowClickedEvent, selsmartLogoClickedEvent } from '../../shared/events/additional.event';
import selsmartLogo from '../../assets/images/Selsmart_Logo_With_TM.webp'

interface Category {
    cat_id: number;
    title: string;
    parent_cat_id: number | null;
    slug: string;
    parent_title: string;
    children: Category[];
}


const Header: React.FC = () => {

    const API = useApi()
    const dispatch = useDispatch();
    const geoInfo = useSelector(selectGeo)
    const { isAuthorized} = useUser();
    const loggedUser = useSelector(selectLoggedUser)
  

    const isCityPopupVisible = useSelector(selectShowCityPopup)
    const isPincodeLoading = useSelector(selectIsPincodeLoading)
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userName, setUserName] = useState('');
    const [cities, setCities] = useState<{ name: string }[]>([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
   
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCity, setSelectedCity] = useState<string | null>(null);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [session_code, setSessCode] = useState<string | null>(null);
    const [categories, setCategories] = useState([]);
    const [showSuggestionss, setShowSuggestionss] = useState(false);
    const { cartQuantity, setCartQuantity } = useCart();
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState<any[]>([]);
    const [searchData, setsearchData] = useState<any[]>([]);
    const { user_id, user_name, city_name ,fetchCsrfToken,setPreviousPincode} = useUser();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const { refreshKey } = useRefresh();
    const [highlightedIndex, setHighlightedIndex] = useState(-1); // Track highlighted suggestion
    const suggestionsRef = useRef<HTMLUListElement>(null);
    const [loginShowKey, setloginShowKey] = useState<string | null>(null);
    const wasAuthorizedRef = useRef<boolean>(isAuthorized);
    const redirectTimeoutRef = useRef<number | null>(null);
    const [showResources, setShowResources] = useState(false);
    const location = useLocation();
    const { globalSearchTerm, setGlobalSearchTerm, sess_code} = useUser();
    const navigate = useNavigate();
    const { fetchCartQuantity } = useCart();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const redirect_url = process.env.REACT_APP_REDIRECT
    const isUpdateLinkEnabled = process.env.REACT_APP_ENABLE_UPDATE_PAGE === 'true';




    /**
     * Navigate user to sell-now page when session expire
     * 
     * whenever a session will be expire 
     * "isAuthorized is set to false through configurtion.ts file
     * and here we implemented a hook which render when "isAuthorized"
     * change its value.
     * 
     */

   useEffect(() => {
    const wasAuthorized = wasAuthorizedRef.current;
    if (wasAuthorized && !isAuthorized) {
      sessionStorage.clear();
      dispatch(setLoggedUser(false));
      dispatch(setCartCount(0));
      if(!loggedUser.isUserLoggedOut){
      showToastWarning('Session Expired');
      }
      
      navigate(SitePath.SELL_NOW_PAGE)
     
    }
    wasAuthorizedRef.current = isAuthorized;
    return () => {
      if (redirectTimeoutRef.current) {
        clearTimeout(redirectTimeoutRef.current);
        redirectTimeoutRef.current = null;
      }
    };
   },[isAuthorized, dispatch])

   /**
    * 
    * Again we also check if user navigate to different pages, 
    * we hit an auth api to detech their session
    */

     useEffect(()=>{
        console.info('header auth check')
        const response = API.API_V1.auth.getCheckAuth()
        window.scrollTo({top:0, behavior:'smooth'})
   }, [window.location.href, isAuthorized])

   const handleResourceToggle = () => {
        setShowResources(prev => !prev);
        };

  

    const handleLoginShow = () => {
        
      if(isLoggedIn == false){
        setloginShowKey('Login')
      }
    };
    useEffect(() => {
        handleLoginShow()
        const loginState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loginState);
        const storedUserName = localStorage.getItem('userName') || 'User';
        setUserName(storedUserName);
    }, [refreshKey]);

    useEffect(() => {
        
        handleLoginShow()
        const loginState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loginState);
        const storedUserName = localStorage.getItem('userName') || 'User';
        setUserName(storedUserName);
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${backendUrl}api/v1/product-category`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        
                        credentials: "include",
                        mode:"cors"
        
                      }
                );
                const data = await response.json();     
                setCategories(data.data);
            } catch (error) {
                //console.error('Error fetching categories:', error);
            }
        };

        fetchCategories();
    }, []);


    useEffect(() => {
       

        const fetchCities = async () => {
            try {
                const response = await fetch(`${backendUrl}api/v2/all-city`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        
                        credentials: "include",
                        mode:"cors"
        
                      }
                );
                const data = await response.json();
                if (data.data && Array.isArray(data.data[0])) {
                    setCities(data.data[0]);
                }
                const login = localStorage.getItem("isLoggedIn")
                if (login === 'true') {
                    fetchCartQuantity(sess_code || 'defaultSessionCode')
                }
            } catch (error) {
                //console.error('Error fetching cities:', error);
            }
        };
        fetchCities();
    }, []);
   
    const fetchSuggestions = async (inputValue: string) => {
        if (inputValue.trim()) {
            try {
                const response = await fetch(
                    `${backendUrl}api/v1/product/search?title=${encodeURIComponent(inputValue)}`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        credentials: "include",
                mode:"cors"
 
                  
                      }
                );
                const data = await response.json();
                   // Log the full response for debugging

                const products = data.data?.data; // Get products from response
                if (Array.isArray(products) && products.length > 0) {
                    setSuggestions(products); // Set suggestions to display to the user
                } else {
                    setSuggestions([]); // No suggestions found
                }
                setShowSuggestions(true); // Always show suggestions box
            } catch (error) {
                //console.error("Error fetching suggestions:", error);
                setSuggestions([]); // Clear suggestions on error
                setShowSuggestions(true); // Show "No data found" in case of an error
            }
        } else {
            setSuggestions([]); // Clear suggestions when input is empty
            setShowSuggestions(false); // Hide suggestions when input is empty
        }
    };


    const handleSearch = async () => { 
        if(searchTerm.length == 0){
            window.location.href = `/sell-used-appliances`;
        }
        if (searchTerm.trim()) {
            localStorage.setItem("GlobalSearchTerm", searchTerm.trim());
            try {
                const response = await fetch(
                    `${backendUrl}api/v1/product/search?title=${encodeURIComponent(searchTerm)}`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        credentials: "include",
                        mode:"cors"        
                  
                      }
                );
                const data = await response.json();
                const products = data.data.data;
               const sess_code = loggedUser.sessionCode || ''
                if (Array.isArray(products) && products.length > 0) {
                    if (window.location.pathname === '/sell-used-appliances') {
                        if(user_id){
                              const priceFetch = 'true'
                                          const reqbody = { 
                                   searchProduct:searchTerm,
                                  }
                                  const resp = API.API_V1.activity.userActivity(reqbody,sess_code,UserActivityType.user,{checkout:'search'})

                        }
                     
                        setsearchData(data.data.data)
                        
                        if(searchData){
                         window.location.href = `/sell-used-appliances?product=${encodeURIComponent(searchTerm)}`; // Force refresh
                        }
                    
                    
                       
                    } else {
                        if(user_id){
                                    const priceFetch = 'true'
                                          const reqbody = { 
                                   searchProduct:searchTerm,
                                  }
                                  const resp = API.API_V1.activity.userActivity(reqbody,sess_code,UserActivityType.user,{checkout:'search'})
                    }

                       
                        navigate(`/sell-used-appliances?product=${encodeURIComponent(searchTerm)}`, { state: { searchData: searchData } }); // Navigate without reload
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }

                } else {
                      
                }
            } catch (error) {
                //console.error('Error fetching search results:', error);
            }
        }
    };

    const handleSuggestionClick = (product: any) => {
        // //  
        setSearchTerm(product.title); // Set the search term to the clicked suggestion
        setGlobalSearchTerm(product.title)
        setShowSuggestions(false); // Hide suggestions after selection
        localStorage.setItem("GlobalSearchTerm", product.title);


        if (window.location.pathname === '/sell-used-appliances') {
            window.location.href = `/sell-used-appliances?product=${product.title}`; // Force refresh
            // navigate(`/sell-used-appliances?cat_id=${product.cat_id}`);
        } else {
            navigate(`/sell-used-appliances?product=${product.title}`); // Navigate without reload
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }

        // Navigate to the appropriate page
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (suggestionsRef.current && !suggestionsRef.current.contains(event.target as Node)) {
                setShowSuggestions(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('click', handleClickOutside);
        };

    }, []);

    // const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => setSelectedCity(e.target.value);

   

    

    const handleSelectCityClick = () => {
        dispatch(setShowCityPopup(true))
        dispatch(setIsForceShow(true))
    };


  



    const handleListShowCat = () => {
        if(showSuggestionss == true){
            setShowSuggestionss(false)
        }else{
            setShowSuggestionss(true)
        }
        
    };

   

    useEffect(() => {
        if (showModal) {
          disableBodyScroll(); // Disable body scrolling when modal opens
        } else {
          enableBodyScroll(); // Enable body scrolling when modal closes
        }
    
        // Cleanup to re-enable scrolling if component unmounts
        return () => enableBodyScroll();
      }, [showModal]);



    const disableBodyScroll = () => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on body when modal is open
      };
      
      // Function to enable scrolling on the body
      const enableBodyScroll = () => {
        document.body.style.overflow = 'auto'; // Enable scrolling on body when modal is closed
      };

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    
    return (

        <header className="sls-mb-6">
            <nav className="navbar navbar-expand-xl bg-white">
                <div className="container">

                    <a className="navbar-brand" href={redirect_url} onClick={() => selsmartLogoClickedEvent()}>
                        <img src={selsmartLogo} alt="Selsmart Logo" width="300" height="100" style={{width:"100%", height:"auto"}} />
                        {/* <img src="/assets/images/selsmart_diwali.png" alt="Selsmart Logo" /> */}
                    </a>

                        <div className="location">
                            <div className='select-location' onClick={handleSelectCityClick} >
                                <FontAwesomeIcon icon={faMapMarkerAlt} className='icon-loc' />
                                {
                                    isPincodeLoading 
                                    ? ( <Spinner animation="border" size="sm" />
 ) 
                                    : (
                                        <p className="location-btn">
                                            {geoInfo.city.cityName || 'Select City'}
                                        </p>
                                    )
                                }
                                
                               
                            </div>

                              
                          
                            {isLoading && (
                                <div className="loader">Loading...</div> // Your loader component or styling here
                            )}
                        </div>

                        <div className="search for_mob">
                            <div className="search-input-container">
                                <input
                                    type="text"
                                    placeholder="Sell 'Products'"
                                    value={globalSearchTerm}
                                    onChange={(e) => {
                                        const value = e.target.value.trimStart(); // Allow spaces between words but no leading spaces
                                        setSearchTerm(value);
                                        setGlobalSearchTerm(value)


                                        if (value !== '') {
                                            fetchSuggestions(value);
                                        } else {
                                            setSuggestions([]); // Clear suggestions when the input is empty
                                            setShowSuggestions(false); // Hide suggestions list
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            if (searchTerm.trim() !== '' && suggestions.length > 0) {
                                                // handleSearch();
                                            }
                                            
                                        }   
                                    }}
                                />
                                <button
                                    className="search-btn"
                                    // onClick={handleSearch}
                                    disabled={searchTerm.trim() === '' || suggestions.length === 0} // Disable if no input or no suggestions
                                >
                                    <img className="icon-search" src={searchbarImage} alt="Search" />
                                </button>
                            </div>

                            {/* Display suggestions or "No data found" */}
                            {showSuggestions && (
                                <ul className="suggestions-list" ref={suggestionsRef} autoFocus={true} >
                                    {suggestions.length > 0 ? (
                                        suggestions.map((product) => (
                                            <li
                                                key={product.product_id}
                                                tabIndex={1}
                                                // onClick={() => handleSuggestionClick(product)}
                                                onTouchStart={() => handleSuggestionClick(product)}
                                            >
                                                {product.title}
                                            </li>
                                            
                                        ))
                                        
 
                                    ) : (
                                        <li>No data found</li> // Display message when no suggestions exist
                                    )}
                                    
                                </ul>
                            )}

                        </div>

                        <div className="cart for_mob">
                           <CartIcon />
                        </div>

                        <button
                            className="navbar-toggler"
                            type="button"
                            onClick={toggleNavbar}
                            aria-controls="navbarSupportedContent"
                            aria-expanded={isOpen}
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>


                        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
                            <div className="search for_web">
                                <div className="search-input-container">
                                    <input
                                        type="text"
                                        placeholder="Sell 'Products'"
                                        value={globalSearchTerm}
                                        onChange={(e) => {
                                            const value = e.target.value.trimStart(); // Allow spaces between words but no leading spaces
                                            setSearchTerm(value);
                                            setGlobalSearchTerm(value)

                                            if(value == '' || value == undefined)
                                                  window.location.href = `/sell-used-appliances`;
                                            if (value !== '') {
                                                fetchSuggestions(value);

                                            } else {
                                                setSuggestions([]); // Clear suggestions when the input is empty
                                                setShowSuggestions(false); // Hide suggestions list
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <button
                                        className="search-btn"
                                        onClick={handleSearch}
                                        disabled={searchTerm.trim() === '' || suggestions.length === 0} // Disable if no input or no suggestions
                                    >
                                        <img className="icon-search" src={searchbarImage} alt="Search" />
                                    </button>
                                </div>

                                {/* Display suggestions or "No data found" */}
                                {showSuggestions && (
                                    <ul className="suggestions-list" ref={suggestionsRef}>
                                        {suggestions.length > 0 ? (
                                            suggestions.map((product) => (
                                                <li 
                                                    tabIndex={1}
                                                    autoFocus = {true}
                                                    key={product.product_id}
                                                    onClick={() => handleSuggestionClick(product)}
                                                >
                                                    {product.title}
                                                </li>
                                            ))
                                        ) : (
                                            <li>No data found</li> // Display message when no suggestions exist
                                        )}
                                    </ul>
                                )}

                            </div>

                            <ul className="navbar-nav ms-auto mb-2- mb-lg-0">
                                <li className="nav-item">
                                    <Link
                                        className={`nav-link ${location.pathname === '/' ? 'bold' : ''}`} 
                                        to='/'
                                        // onClick={() => handleNavClick('/')}

                                         onClick={() => {
                                        homeButtonClickedEvent(location.pathname);
                                        }}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li
                                    className="nav-item drop_down_list"
                                    onMouseEnter={() => setShowSuggestionss(true)}
                                    onMouseLeave={() => setShowSuggestionss(false)}
                                    style={{ position: 'relative' }}
                                >
                                    <div className='sellnow_li'>
                                    <i className="fa-solid fa-chevron-left" onClick={handleListShowCat}></i>
                                    <Link
                                        className="nav-link"
                                        style={{
                                           
                                            cursor: 'pointer',
                                            // fontWeight: location.pathname === '/sell-used-appliances' ? 'bold' : 'normal',
                                        }}
                                        to="/sell-used-appliances"
                                         onClick={() => {
                                        sellNowClickedEvent("Sell Now", location.pathname);
                                        }}
                                        
                                    >
                                        Sell Now
                                    </Link>
                                   
                                    </div>

                                    {showSuggestionss && (
                                        <ul className="suggestion-list-sell">
                                            {categories.map((category: any) => (
                                                <li key={category.cat_id} className="suggestion-item-sell">
                                                    <Link to={`/${encodeURIComponent(category.slug.trim())}`} className="suggestion-link-sell"
                                                     onClick={() => {
                                                            categoryViewEvent(category.slug);
                                                            sellNowClickedEvent(category.title, location.pathname);
                                                        }}
                                                    >
                                                        {category.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>

                                 <li
                                className="nav-item drop_down_list"
                                onMouseEnter={() => setShowResources(true)}
                                onMouseLeave={() => setShowResources(false)}
                                style={{ position: "relative" }}
                            >
                                <div className="sellnow_li">
                                    <i
                                        className="fa-solid fa-chevron-left"
                                        onClick={handleResourceToggle}
                                    ></i>

                                    <Link
                                        className="nav-link"
                                        style={{ cursor: "pointer" }}
                                        to=""
                                        role='button'
    
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        Resources
                                    </Link>
                                </div>

                                {showResources && (
                                    <ul className="suggestion-list-sell">
                                        <li className="suggestion-item-sell">
                                            <Link
                                                to="/blogs"
                                                className="suggestion-link-sell"
                                                onClick={() => setShowResources(false)}
                                            >
                                                Blogs
                                            </Link>
                                        </li>

                                      {isUpdateLinkEnabled && (
                                        <li className="suggestion-item-sell">
                                            <Link
                                                to="/updates"
                                                className="suggestion-link-sell"
                                                onClick={() => setShowResources(false)}
                                            >
                                                Updates
                                            </Link>
                                        </li>
                                      )}
                                       
                                    </ul>
                                      
                                )}
                                
                            </li>




                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${location.pathname === '/faq' ? 'bold' : ''}`}
                                        href="/faq"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent default link behavior
                                             faqClickedEvent("Header FAQ",location.pathname);
                                            window.open('/faq', '_blank'); // Open in a new tab
                                        }}
                                    >
                                        FAQs
                                    </a>
                                </li>
                                {/* <li className="nav-item">
                                    <Link
                                        className={`nav-link ${location.pathname === '/blogs' ? 'bold' : ''}`}
                                        to="/blogs"
                                        // target="_blank"
                                        // rel="noopener noreferrer"
                                        // onClick={(e) => {
                                        //     e.preventDefault(); // Prevent default link behavior
                                        //     window.open('/blog', '_blank'); // Open in a new tab
                                        // }}
                                        
                                    >
                                        Blogs
                                    </Link>
                                </li> */}

                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${location.pathname === '/about-us' ? 'bold' : ''}`}
                                        href="/about-us"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent default link behavior
                                            aboutUsClickedEvent(location.pathname);
                                            window.open('/about-us', '_blank'); // Open in a new tab
                                        }}
                                    >
                                        About Us
                                    </a>
                                </li>
                                <li className="nav-item login_botn" key={refreshKey}>
                                    <div className="sign-in" key={refreshKey}>
                                       <LoginInitialsButton />
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div className="cart for_web">
                                       <CartIcon />
                                    </div>
                                </li>
                            </ul>

                        </div>
                        {/* <button className="hamburger-menu" onClick={toggleMobileMenu}>
                                        <FontAwesomeIcon icon={faBars} />
                                    </button> */}
                        {/* </div> */}
                        {/* </div> */}
                    </div>
                    {/* Mobile Menu */}
                </nav>
              
            </header>
       
    );

};

export default Header;
